import { combineReducers } from 'redux';
import customerFeedbackReducer from './feedback';
import customerListReducer from './list';
import customerLoyaltyReducer from './loyalty';
import customerLoyaltySubscriptionReducer from './loyaltySubscription';
import itemReducer from './item';

export default combineReducers({
  feedback: customerFeedbackReducer,
  list: customerListReducer,
  loyalty: customerLoyaltyReducer,
  loyaltySubscription: customerLoyaltySubscriptionReducer,
  item: itemReducer,
});
